import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { autenticado } from './services/auth';

import TelaLogin from './screens/padrao/tela-login/index';
import Home from './screens/padrao/home/index';
import Pessoa from './screens/pessoa/tela-lista-pessoa/index';
import CadastroPessoa from './screens/pessoa/cadastro-pessoa/index';
import Produto from './screens/produto/tela-lista-produto';
import CadastroProduto from './screens/produto/cadastro-produto';
import GrupoImposto from './screens/grupo-imposto/tela-lista-grupo-imposto';
import CadastroGrupoImposto from './screens/grupo-imposto/cadastro-grupo-imposto';
import Nfe from './screens/nota-fiscal/tela-lista-nfe';
import Nfce from './screens/nota-fiscal-consumidor/tela-lista-nfce';
import CadastroNfe from './screens/nota-fiscal/cadastro-nfe';
import CadastroNfce from './screens/nota-fiscal-consumidor/cadastro-nfce';
import CadastroEmpresa from './screens/empresa/cadastro-empresa';
import Certificado from './screens/configuracao/certificado';
import TelaConfiguracao from './screens/configuracao/tela-configuracao';
import Ajuda from './screens/ajuda';
import TelaPrimeiroAcesso from './screens/configuracao/tela-primeiro-acesso'

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            autenticado() ? (
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: "/", state: { from: props.location } }} />
            )
        }
    />
);

export default function Routes({ history }) {

    return (
        <BrowserRouter>
            <Switch>
                <Route exact path='/' component={TelaLogin} />
                <Route exact path='/cadastro-empresa' component={CadastroEmpresa} />
                <PrivateRoute exact path='/home' component={Home} />
                <PrivateRoute exact path='/ajuda/:categoria/:campo' component={Ajuda} />
                <PrivateRoute exact path='/pessoa' component={Pessoa} />
                <PrivateRoute exact path='/cadastro-pessoa' component={CadastroPessoa} />
                <PrivateRoute exact path='/produto' component={Produto} />
                <PrivateRoute exact path='/cadastro-produto' component={CadastroProduto} />
                <PrivateRoute exact path='/grupo-imposto' component={GrupoImposto} />
                <PrivateRoute exact path='/cadastro-grupo-imposto' component={CadastroGrupoImposto} />
                <PrivateRoute exact path='/nfe' component={Nfe} />
                <PrivateRoute exact path='/nfce' component={Nfce} />
                <PrivateRoute exact path='/cadastro-nfe' component={CadastroNfe} />
                <PrivateRoute exact path='/cadastro-nfce' component={CadastroNfce} />
                <PrivateRoute exact path='/certificado' component={Certificado} />
                <PrivateRoute exact path='/configuracoes' component={TelaConfiguracao} />
                <PrivateRoute exact path='/primeiro-acesso' component={TelaPrimeiroAcesso} />
            </Switch>
        </BrowserRouter>
    )
}